import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useUIMode } from "../hooks/useUIMode";
import { UserContext } from "../UserContext";
import { hasAnyPerm } from '../utils/uiUtils';
import { useTranslation } from 'react-i18next';
import { axiosAuth_SECURITY_API } from '../utils/AxoisUtilComponent';
import { formatDate } from '../utils/timeUtils';
import TemplateListView    from "./TemplateListView";
//import DatakeyAuditDetailsView from "./DatakeyAuditDetailsView";


const DatakeyAudit = () => {

  const { t }    = useTranslation(["common"]);
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  const { uiMode, setUIMode, /*objDetails,*/ setObjDetails } = useUIMode('LIST');

  const PAGE_STATE_STORAGE_KEY = "DatakeyAudit.pageState";
  const defaultPageState = {
    searchTerms: null,
    sortCol: null,
    sortDir: null,
    perPage: 25,
    currPage: 1
  };

  const [pageState, setPageState] = useState(() => {
    try {
      const savedPageState = sessionStorage.getItem(PAGE_STATE_STORAGE_KEY);
      return savedPageState
        ? { ...defaultPageState, ...JSON.parse(savedPageState) }
        : defaultPageState;
    } catch (error) {
      return defaultPageState;
    }
  });

  useEffect(() => {
    sessionStorage.setItem(PAGE_STATE_STORAGE_KEY, JSON.stringify(pageState));
  }, [pageState]);

  // Initialize state
  useEffect(() => {

    // Route to home page if not authorized
    if (!hasAnyPerm(user, ["BuildingAdminGeneralWriteAccess"], true)) {
      navigate("/AdminHome/Dashboard", {
        state: {
          //...values
          target: 'Dashboard'
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  // ----- Data Table stuff -----

  const tableColumns = [
    {
      name: t("I18N_Key_id"),
      selector: row => row.keyId,
      sortable: true,
      sortField: 'keyId',
      grow: 1
    },
    {
      name: t("I18N_Principle"),
      selector: row => row.principleUsername,
      sortable: true,
      sortField: 'principleUsername',
      grow: 1.5
    },
    {
      name: t("I18N_Event"),
      selector: row => row.event
    },
    {
      name: t("I18N_Object"),
      selector: row => row.object
    },
    {
      name: t("I18N_Status"),
      selector: row => row.status
    },
    {
      name: t("I18N_Info"),
      selector: row => row.info,
      cell: row => (
        row.info ? JSON.stringify(row.info) : ''
      ),
      grow: 3
    },
    {
      name: t("I18N_Time_created"),
      selector: row => formatDate(row.timeCreated),
      sortable: true,
      sortField: 'timeCreated',
      grow: 1.25,
      wrap: true
    }
  ];

  // ----- END - Data Table stuff -----

  return (
    <Fragment>

      {(uiMode === 'LIST')    ? <TemplateListView pageState={pageState}
                                                  axiosAPI={axiosAuth_SECURITY_API}
                                                  apiObjName={'data-key-logs'}
                                                  listPageTitle={t("I18N_DatakeyAudit_Management")}
                                                  searchTooltip={t("I18N_Search")}
                                                  tableColumns={tableColumns}
                                                  hideDeleteIcon={true}
                                                  onUIMode={setUIMode}
                                                  onSetPageState={setPageState} onSetObjDetails={setObjDetails} /> : null}
{/*
      {(uiMode === 'DETAILS') ? <DatakeyAuditDetailsView onUIMode={setUIMode} objDetails={objDetails} />                  : null}
*/}

    </Fragment>
  )
}

export default DatakeyAudit;
